module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-47.06a8bbeb.png";